export const TRANSLATION_CONFIG = {
  appNamespace: "frontend",
  fetchNamespace: "",
};
